import { BaseMenuEntityConfiguration } from '../entityConfigs/index.js';
export default new BaseMenuEntityConfiguration({
    consumable: false,
    filters: [],
    hasDescription: true,
    hasHours: true,
    hasImage: true,
    hasVariations: false,
    hasPos: true,
    lists: [
        {
            collection: 'Item',
            name: 'items',
            primaryRelationship: true,
        },
        {
            collection: 'Category',
            name: 'upsellCategories',
        },
    ],
    name: 'Category',
    options: {},
    pluralizedName: 'Categories',
    sellable: false,
    sortKeys: [],
    unlinkedOptions: [],
    version: 6,
});
//# sourceMappingURL=category.js.map